import { Popover } from '@headlessui/react'
import {
  AtButton,
  AtButtonVariant,
  AtIcon,
  FocusElement,
  focusElementClasses,
} from '@curran-catalog/curran-atomic-library'

import { ServerState } from 'pages/catalog/[[...slug]]'
import { CurrentRefinements } from './current-refinements'
import { RefinementsPanel } from './refinements-panel'
import { FiltersProps } from '@templates/tm-catalog'
import { SortBy } from '@utils/algolia-widgets'

const MobileMenuFilters = ({
  serverFilterFacets,
  showRefinements,
  onShowRefinements,
}: {
  serverFilterFacets: MenuFiltersProps['serverFilterFacets']
  showRefinements: FiltersProps['showMobileRefinements']
  onShowRefinements: FiltersProps['onShowMobileRefinements']
}) => {
  return (
    <Popover className={`tw-relative tw-z-30 ${showRefinements ? 'opacity-100 block' : 'hidden opacity-0'}`}>
      <div className="fixed inset-0 bg-transparentBlack" aria-hidden="true" />

      <div className="fixed inset-0">
        <Popover.Panel
          static
          className="bg-white w-screen overflow-y-auto sm:w-2/4 p-4 h-screen relative border-r border-r-outlined-gray"
        >
          <div className="flex flex-col gap-6">
            <div className="flex flex-row justify-end">
              <button
                className={`${focusElementClasses[FocusElement.FOCUS_VISIBLE]}`}
                aria-label="Close menu filters"
                type="button"
                onClick={() => {
                  document.body.style.removeProperty('overflow')
                  document.body.style.removeProperty('touch-action')
                  onShowRefinements()
                }}
              >
                <AtIcon type="close" color="secondary" />
              </button>
            </div>

            <span className="font-medium text-sm text-secondary">SORT BY:</span>
            <SortBy />
          </div>

          <h4 className="font-medium my-6 text-sm text-secondary ">FILTER BY:</h4>

          <div className="flex flex-col justify-between">
            <div className="flex flex-col gap-6 overflow-x-auto h-[calc(100vh-360px)]">
              <div className="flex flex-col gap-2">
                <CurrentRefinements />
                <RefinementsPanel serverFilterFacets={serverFilterFacets} />
              </div>
            </div>

            <div className="flex flex-row gap-4 w-full py-4">
              <AtButton
                className="w-full"
                variant={AtButtonVariant.SECONDARY}
                onClick={() => {
                  document.body.style.removeProperty('overflow')
                  document.body.style.removeProperty('touch-action')

                  onShowRefinements()
                }}
                label="Apply"
              />
            </div>
          </div>
        </Popover.Panel>
      </div>
    </Popover>
  )
}

const DesktopMenuFilters = ({
  serverFilterFacets,
  showRefinements,
}: {
  serverFilterFacets: MenuFiltersProps['serverFilterFacets']
  showRefinements: FiltersProps['showDesktopRefinements']
}) => {
  return (
    <aside
      className={`sticky md:top-24 lg:top-36 md:overflow-y-scroll md:h-[calc(100vh-100px)] lg:h-auto ${
        showRefinements
          ? 'hidden opacity-0 md:opacity-100 md:block md:shrink-0 md:grow-0 md:w-60 lg:w-72'
          : 'hidden opacity-0'
      }`}
    >
      <div className="flex flex-col gap-2">
        <RefinementsPanel serverFilterFacets={serverFilterFacets} />
      </div>
    </aside>
  )
}

type MenuFiltersProps = Omit<FiltersProps, 'onShowDesktopRefinements'> & Pick<ServerState, 'serverFilterFacets'>

export const MenuFilters = ({
  serverFilterFacets,
  showDesktopRefinements,
  showMobileRefinements,
  onShowMobileRefinements,
}: MenuFiltersProps) => {
  return (
    <>
      <MobileMenuFilters
        serverFilterFacets={serverFilterFacets}
        showRefinements={showMobileRefinements}
        onShowRefinements={onShowMobileRefinements}
      />
      <DesktopMenuFilters serverFilterFacets={serverFilterFacets} showRefinements={showDesktopRefinements} />
    </>
  )
}
